import { mergeStyles } from '@cian/utils';
import * as React from 'react';
import * as styles from './OnlyForFairPlayersWrapper.css';

interface IOnlyForFairPlayersWrapperProps {
  children: React.ReactNode;
  className?: string;
}

export const OnlyForFairPlayersWrapper = ({ children, className }: IOnlyForFairPlayersWrapperProps) => {
  return <div {...mergeStyles(styles['wrapper'], className)}>{children}</div>;
};
